import { Button, Form, message, Select } from 'antd';
import { useEffect, useState } from 'react';
import { apiD2r, apiOms } from '../../../shared/api';
import errorHandler from '../../../shared/utils/errorHandler';
import styles from './index.module.scss';
import { Loading } from '../Loading';

interface ISalesmanSelectForm {
	salesmanId?: string;
	orderId: string;
	setLoading: (values: any) => void;
	getPaymentLogs: () => void;
	onPaymentCaptured?: () => void;
}

export const SalesmanSelectForm = ({ salesmanId, orderId, setLoading, getPaymentLogs, onPaymentCaptured }: ISalesmanSelectForm) => {
	const [salesmen, setSalesmen] = useState<[]>([]);
	const [isLoading, setIsLoading] = useState(true);

	const handleHandOverToSalesman = async (values: { salesmanId: string }) => {
		try {
			setLoading(true);
			const response = await apiD2r.post('/invoice/handover-to-salesman', {
				id: orderId,
				salesmanId: values.salesmanId
			});

			if (response.data.status) {
				message.success('Invoice handed over to salesman successfully');
				onPaymentCaptured?.();
				getPaymentLogs();
			}
		} catch (error) {
			errorHandler(error);
		} finally {
			setLoading(false);
		}
	};

	const getSalesmen = async () => {
		try {
			setIsLoading(true);
			const { data } = await apiOms('/salesman');
			if (!data?.status) {
				throw new Error(data?.message);
			}
			setSalesmen(data?.data);
		} catch (error) {
			errorHandler(error);
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		getSalesmen();
	}, [orderId]);

	return (
		<div>
			{isLoading ? (
				<Loading loading={isLoading} /> // You can replace this with a proper loading spinner
			) : (
				<Form
					layout="horizontal"
					style={{ marginTop: '1rem' }}
					onFinish={handleHandOverToSalesman}
					className={styles.formContainer}
				>
					<Form.Item
						name="salesmanId"
						rules={[{ required: true, message: 'Please select a salesman' }]}
						initialValue={salesmanId} // Keep the initialValue, but it will map correctly with the options
					>
						<Select showSearch placeholder="Select Salesman" optionFilterProp="children" loading={isLoading}>
							{salesmen.map(({ id, firstName, lastName, phone }) => (
								<Select.Option key={id} value={id}>
									{`${firstName} ${lastName}, (${phone})`}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item>
						<Button type="primary" htmlType="submit" style={{ width: '100%' }}>
							Submit
						</Button>
					</Form.Item>
				</Form>
			)}
		</div>
	);
};
